import ActionCable from "action-cable-react-jwt";
import {
  compose,
  setDisplayName,
  withState,
  lifecycle,
  withHandlers 
} from "recompose";
import { connect } from "react-redux";
import { actions } from "../modules/contracts";
import { get } from "lodash";
import { objectToQueryString } from "../helpers/index";
import { getCurrentDealer } from "../modules/dealers";
import { selectors } from "../modules/customers";

const withRedux = connect(
  state => ({
    jwt: get(state, "auth.user.jwt", ""),
    role: state.settings.role,
    currentDealer: getCurrentDealer(state),
    currentCustomer: selectors.getCurrentCustomer(state),
    currentPage: state.contracts.currentPage,
    perPage: state.contracts.perPage,
    currentContract: state.contracts.currentContract,
    searchSnapshot: state.contracts.searchSnapshot
  }),
  {
    fetchCustomerContracts: actions.fetchContractsSeamless,
    fetchStaffContracts: actions.fetchContractsSeamless,
    fetchContract: actions.fetchContractSeamless,
    fetchContractsWithContact: actions.fetchContractsWithContact
  }
);

const withCable = withState("cable", "setCable", null);

export default compose(
  setDisplayName("WithContractWebSocket"),
  withRedux,
  withCable,
  withHandlers({
    handleRecieved: ({
      jwt,
      fetchCustomerContracts,
      fetchStaffContracts,
      fetchContractsWithContact,
      role,
      currentDealer,
      perPage,
      currentPage,
      fetchContract,
      currentContract,
      searchSnapshot,
      currentCustomer
    }) => ({ contract, ...rest }) => {
      if (jwt) {
        if (role === "customer" || role == "contact") {
          fetchCustomerContracts({
            customer_id: currentCustomer.id,
            dealer_id: currentDealer.id
          });
        } else {
          fetchStaffContracts({
            dealer_id: currentDealer.id,
            query_string: objectToQueryString({
              per_page: perPage,
              page: currentPage,
              ...searchSnapshot
            })
          });
        }
        if (currentContract) {
          if (
            currentContract.aasm_state !== contract.aasm_state &&
            currentContract.id === contract.id
          ) {
            fetchContract({
              dealer_id: contract.dealer_id,
              contract_id: contract.tracking_number
            });
          }
        }
      }
    }
  }),
  withHandlers({
    createCable: ({ role, jwt, setCable, handleRecieved }) => () => {
      if (jwt) {
        const newCable = ActionCable.createConsumer(
          process.env.REACT_APP_WEBSOCKET_URL,
          jwt
        );
        newCable.subscriptions.create(
          { channel: "ContractChannel", type: role },
          {
            connected: function() {}, // onConnect
            disconnected: function() {}, // onDisconnect
            received: handleRecieved
          }
        );
        setCable(newCable);
      }
    },
    deleteCable: ({ cable, setCable }) => () => {
      cable && cable.disconnect();
      setCable(null);
    }
  }),
  lifecycle({
    componentDidMount() {
      const { cable, deleteCable, createCable } = this.props;
      cable && deleteCable();
      createCable();
    },
    componentWillReceiveProps(nextProps) {
      if (nextProps.role) {
        if (nextProps.role !== this.props.role) {
          this.props.deleteCable();
          this.props.createCable();
        }
      }
    },
    componentWillUnmount() {
      this.props.deleteCable();
    }
  })
);
